'use client';

import { useTranslations } from 'next-intl';

import UsersSvg from '@/public/icon/users.svg';

export default function Contact({ email }: { email: string }) {
  const t = useTranslations('Pages.Event.EventPagePlaceSection');

  return (
    <button
      onClick={() => window.open(`mailto:${email}`)}
      className='flex w-full items-center space-x-2'
    >
      <UsersSvg />
      <p className='hover:text-primary-filled-default'>{t('contact')}</p>
    </button>
  );
}
